import { render, staticRenderFns } from "./Old.vue?vue&type=template&id=0493972c&scoped=true"
import script from "./Old.vue?vue&type=script&lang=js"
export * from "./Old.vue?vue&type=script&lang=js"
import style0 from "./Old.vue?vue&type=style&index=0&id=0493972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493972c",
  null
  
)

export default component.exports